import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DISCORD_LINK } from '@core/constants/discord.constants';
import { SvgIconComponent } from 'angular-svg-icon';

interface Social {
  icon: string;
  name: string;
  link: string;
}

const SOCIALS: Social[] = [
  {
    icon: 'assets/icons/socials/twitter.svg',
    name: 'twitter',
    link: 'https://x.com/tf2hunt',
  },
  // {
  // icon: 'assets/icons/socials/tiktok.svg',
  // name: 'tiktok',
  // link: 'https://www.facebook.com/',
  // },
  {
    icon: 'assets/icons/socials/discord.svg',
    name: 'discord',
    link: DISCORD_LINK
  },
  // {
  //   icon: 'assets/icons/socials/youtube.svg',
  //   name: 'youtube',
  //   link: 'https://www.facebook.com/',
  // },
];

@Component({
  selector: 'app-site-socials',
  imports: [SvgIconComponent],
  standalone: true,
  templateUrl: './site-socials.component.html',
  styleUrl: './site-socials.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteSocialsComponent {
  socials = SOCIALS;
}
